import { IBlock } from "../../../../framework/src/IBlock";
import { Message } from "../../../../framework/src/Message";
import MessageEnum, {
  getName,
} from "../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../framework/src/RunEngine";
import { RouteComponentProps } from "react-router";
import { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import { withToastProps } from "../../../../components/src/withSnackBar.Web";
import { withLoaderProps } from "../../../../components/src/withLoader.Web";
import CustomPackagInRoadMap from "../CustomPackagInRoadMap.web";
import { intitalQuestion } from "../../../../components/src/PackageList.web";
export const configJSON = require("../config");
export interface CategoryRoot {
  data: Category[];
}

export interface Category {
  id: string;
  type: string;
  attributes: Attributes;
}

export interface Attributes {
  id: number;
  category_name: string;
  features: Features;
}

export interface Features {
  data: Daum2[];
}

export interface Daum2 {
  id: string;
  type: string;
  attributes: Attributes2;
}

export interface Attributes2 {
  id: number;
  feature_id: string;
  package_feature_id?: number;
  tag: string;
  feature_name: string;
  payment_period: string;
  default_cost?: number;
  payment_frequency?: string;
  bump_language?: string;
  package_category: PackageCategory;
}

export interface PackageCategory {
  category_id: number;
  category_name: string;
}

export type Props = RouteComponentProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;

    // Customizable Area Start
    // Customizable Area End
  };

interface S {
  // Customizable Area Start
  accountId: string | null;
  chipData: {
    key: string;
    label: string;
    isFromQuestionFilter?: boolean;
    type?: string;
  }[];
  allFeatureList: CategoryRoot | any[];
  selectedFeatureList: any;
  categoryList: any[];
  token: string | null;
  currentStep: number;
  filterQuestionList: any[];
  currentQuestionIndex: number;
  selectedPackageDetail: null | unknown;
  packageList: any[];
  isCreateFromDefaultTemplate: boolean;
  defaultPackageTemplate: any;
  name: string;
  description: string;
  package_detail_link: string;
  stratagic_rate: number | "";
  markDefaultPriceToPackage:boolean;
  value_margin: number | "";
  contract_period: number | "";
  totalOneTimeFess: number;
  totalRecurringFess: number;
  bumpList: any[];
  is_unfront_payment: boolean;
  unfront_payment_type: "percentage" | "lumpsump";
  unfront_percentage: number;
  unfront_lump_suump_amount: number;
  is_credit_card_upfront: boolean;
  credit_card_surcharge_type: "percentage" | "fixed";
  credit_card_upfront_percentage: number;
  credit_card_upfront_amount: number;
  totalContractValue: number;
  totalContractValueAfterRemovingUnfrontAmount: number;
  custom_package_features: any[];
  totalAvailalbeFeatures: number;
  selectedCategory: any;
  selectedSearchField: any;
  mode: "create" | "edit";
  packageType: string;
  edit_package_id: any;
  customPackageCreatedForDefaultPackage: any;
  createCustomPackageId: any;
  allFeatureListForPricingScreen: any[];
  isFromRoadMap: boolean;
  roadMap: any;
  default_firm_finance_strategic_price: any;
  default_strategic_price: any;
  is_monthly_payment_term:boolean,
  is_quarterly_payment_term:boolean,
  is_yearly_payment_term:boolean,
  is_weekly_payment_term:boolean,
  is_semi_annual_payment_term:boolean,
  is_due_on_completion_payment_term:boolean,
  is_one_time_payment_term:boolean,
  defaultStrategicRates : {
    strategic_rate : string;
    contract_period : string;
  };
  // Guards against double-submitting the save request (creating duplicate packages).
  isSavingCustomPackage: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class CustomPackageCreationContainerController extends CustomPackagInRoadMap<
  Props,
  S,
  SS
> {
  updateSurveyLogCallId: string = "";
  getAllFeaturesCallId: string = "";
  getAllFeaturesofSelectedPackageCallId: string = "";
  getPackagesApiCallId: string = "";
  getBumpsApiCallId: string = "";
  createCustomPackageCallId: string = "";
  getAllFeaturesForPriceingScreenCallId: string = "";
  pricingFormValues: any = null;
  getAccountDetailId:string='';

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.AlertMessage),
      // Customizable Area End
    ];

    this.state = {
      accountId: null,
      token: null,
      selectedCategory: [],
      chipData: [],
      packageList: [],
      categoryList:[],
      selectedSearchField: "",
      selectedFeatureList: [],
      allFeatureList: [],
      currentStep: 0,
      isCreateFromDefaultTemplate: false,
      defaultPackageTemplate: "select",
      allFeatureListForPricingScreen: [],
      isFromRoadMap: false,
      roadMap: null,
      filterQuestionList: intitalQuestion,
      currentQuestionIndex: 0,
      selectedPackageDetail: {},
      name: "Custom Package",
      description: "",
      package_detail_link: "",
      stratagic_rate: "",
      markDefaultPriceToPackage:false,
      value_margin: "",
      contract_period: "",
      totalOneTimeFess: 0,
      totalRecurringFess: 0,
      is_unfront_payment: false,
      unfront_payment_type: "percentage",
      unfront_percentage: 0,
      unfront_lump_suump_amount: 0,
      is_credit_card_upfront: false,
      credit_card_surcharge_type: "fixed",
      credit_card_upfront_percentage: 0,
      credit_card_upfront_amount: 0,
      bumpList: [],
      totalContractValue: 0,
      totalContractValueAfterRemovingUnfrontAmount: 0,
      custom_package_features: [],
      totalAvailalbeFeatures: 0,
      mode: "create",
      packageType: "",
      edit_package_id: null,
      customPackageCreatedForDefaultPackage: null,
      createCustomPackageId: null,
      isSavingCustomPackage: false,
      default_firm_finance_strategic_price: null,
      default_strategic_price: null,
      is_monthly_payment_term:false,
      is_quarterly_payment_term:false,
      is_yearly_payment_term:false,
      is_weekly_payment_term:false,
      is_semi_annual_payment_term:false,
      is_due_on_completion_payment_term:false,
      is_one_time_payment_term:false,
      defaultStrategicRates : {
        strategic_rate : '',
        contract_period : '',
      },
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  setFirmFinanceIdealPriceState = (responseJson: any) => {
    if (responseJson?.data?.id) {
      this.setState({
        default_firm_finance_strategic_price:
          responseJson?.data?.attributes?.default_firm_finance_strategic_price,
        default_strategic_price:
          responseJson?.data?.attributes?.default_strategic_price,
      });
    }
  };

  handleSelectedPackageFeatureList = (responseJson: any) => {
    this.props.hideLoader();
    this.setFirmFinanceIdealPriceState(responseJson);
    if (responseJson.data?.attributes?.features?.data?.length) {
      const packageData =
        responseJson.data?.attributes?.custom_package_managements?.data
          ?.attributes || responseJson?.data?.attributes;
      let selectedData = packageData?.features?.data || [];
      selectedData = selectedData.map((item: any, index: any) => {
        return {
          ...item,
          attributes: {
            ...item.attributes,
            // Preserve the CustomPackageFeature DB id so it is echoed on save (PUT),
            // otherwise the backend re-creates the feature -> duplication.
            new_id: item.attributes.new_id ?? item.attributes.id,
            unique_feature_id:
              item.attributes.feature_id +
              "_" +
              item.attributes.id +
              "_" +
              index,
          },
        };
      });
      this.setState(
        {
          customPackageCreatedForDefaultPackage:
            responseJson.data?.attributes?.custom_package_managements?.data,
          selectedFeatureList: selectedData,
          name: packageData?.name || "",
          description: packageData?.description || "",
          package_detail_link: packageData?.package_detail_link || "",
          stratagic_rate: packageData?.stratagic_rate || "",
          value_margin: packageData?.value_margin || "",
          contract_period: packageData?.contract_period || "",
          is_unfront_payment: packageData?.payment_term?.is_upfront || false,
          unfront_payment_type:
            packageData?.payment_term?.upfront_percentage > 0
              ? "percentage"
              : "lumpsump",
          unfront_percentage:
            packageData?.payment_term?.upfront_percentage || 0,
          unfront_lump_suump_amount:
            packageData?.payment_term?.upfront_amount || 0,
          is_credit_card_upfront: packageData?.payment_term?.is_credit_card_upfront || false,
          credit_card_surcharge_type:
            packageData?.payment_term?.credit_card_upfront_amount > 0
              ? "fixed"
              : "percentage",
          credit_card_upfront_percentage:
            packageData?.payment_term?.credit_card_upfront_percentage || 0,
          credit_card_upfront_amount:
            packageData?.payment_term?.credit_card_upfront_amount || 0,
          is_monthly_payment_term:packageData?.payment_term?.is_monthly_selected,
          is_quarterly_payment_term:packageData?.payment_term?.is_quarterly_selected,
          is_yearly_payment_term:packageData?.payment_term?.is_yearly_selected,
          is_weekly_payment_term:packageData?.payment_term?.is_weekly_selected,
          is_semi_annual_payment_term:packageData?.payment_term?.is_semi_annual_selected,
          is_due_on_completion_payment_term:packageData?.payment_term?.is_due_on_completion_selected,
          is_one_time_payment_term:packageData?.payment_term?.is_one_time_selected,
        },
        () => {
          this.getAllFeatures();
        }
      );
    } else {
      this.getAllFeatures();
      this.handleApiError(responseJson);
    }
  };
  handleGetPackagesResponseInCustomPackage = (responseJson: any) => {
    this.props.hideLoader();
    if (responseJson?.data) {
      this.setState({
        packageList: responseJson?.data,
      });
    } else {
      this.handleApiError(responseJson);
    }
  };
   getDeafultPricing=()=>{
      const headers = {
        "content-type": configJSON.validationApiContentType,
        token: this.state.token,
      };
  
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
  
      this.getAccountDetailId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), `account_block/accounts/${localStorage.getItem('accountId')}`);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(headers));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
     
      runEngine.sendMessage(requestMessage.id, requestMessage);
    }

  handleCreatePackageResponse = (responseJson: any) => {
    this.props.hideLoader();
    // Release the double-submit guard for every outcome (success or error).
    this.setState({ isSavingCustomPackage: false });
    if (responseJson?.data) {
      this.setState(
        {
          createCustomPackageId: responseJson?.data?.id,
        },
        () => {
          this.props.showToast({
            type: "success",
            message: "Custom Package created successfully",
          });
          this.props.history.push("/home/settings/pricing/firmPricing");
        }
      );
    } else {
      this.handleApiError(responseJson);
    }
  };

   handleDefaultPricing=(responseJson:any)=>{
     this.setState({defaultStrategicRates:{contract_period:responseJson.data.attributes.contract_period,
      strategic_rate:responseJson.data.attributes.strategic_rate
    },
      markDefaultPriceToPackage:responseJson.data.attributes.apply_default_price_to_packages
    })
   }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if(this.getAllCategoryListCallId == apiRequestCallId){
          this.handleAllCategoryList(responseJson);
      }else if (this.getAllFeaturesCallId == apiRequestCallId) {
        this.handleAllFeatureList(responseJson);
      } else if (
        this.getAllFeaturesofSelectedPackageCallId === apiRequestCallId
      ) {
        this.handleSelectedPackageFeatureList(responseJson);
      } else if (apiRequestCallId === this.getPackagesApiCallId) {
        this.handleGetPackagesResponseInCustomPackage(responseJson);
      } else if (apiRequestCallId === this.getBumpsApiCallId) {
        this.handleGetBumpResponse(responseJson);
      } else if (apiRequestCallId === this.createCustomPackageCallId) {
        this.handleCreatePackageResponse(responseJson);
      } else if (
        apiRequestCallId === this.getAllFeaturesForPriceingScreenCallId
      ) {
        this.handleAllFeatureListForPricing(responseJson);
      } if(apiRequestCallId == this.getAccountDetailId){
        this.handleDefaultPricing(responseJson)
      }
    } else if (getName(MessageEnum.AlertMessage) === message.id) {
      const AlertBodyMessage = message.getData(
        getName(MessageEnum.AlertBodyMessage)
      );
      this.props.showToast({
        type: "error",
        message: AlertBodyMessage,
      });
    }
  }
onPricingFormChange(values: any) {
  this.pricingFormValues = values;
}

  getCustomPackageData = (isCreate: boolean) => {
    const values = this.pricingFormValues;
    const data = {
      custom_package: {
        name: this.state.name,
        description: this.state.description,
        package_detail_link: this.state.package_detail_link,
        stratagic_rate: this.state.stratagic_rate,
        value_margin: this.state.value_margin,
        contract_period: this.state.contract_period,
        package_management_id:
          this.state.packageType != "custom_package_management"
            ? this.state.edit_package_id
            : undefined,
        custom_package_features_attributes: this.state.custom_package_features.map(
          (feature, index) => {
            return {
              feature_id: feature?.feature_id,
              custom_package_feature_category_id: feature?.custom_package_feature_category_id,
              tag: feature?.tag,
              feature_name: feature?.feature_name_new || feature?.feature_name,
              payment_period: feature?.payment_period,
              default_cost: feature?.default_cost,
              package_category_id: feature?.package_category_id,
              package_feature_id: feature?.package_feature_id,
              hour: feature?.hour,
              id: !isCreate ? feature?.new_id : undefined,
              strategic_rate: feature?.stratagic_rate,
              payment_frequency: feature?.payment_frequency || undefined,
              _destroy: feature?._destroy || undefined,
              order_number: feature?.order_number || index,
              custom_package_bumps_attributes: feature.custom_package_bumps_attributes.map(
                (bump: any) => {
                  const bumpNew = this.state.bumpList.find((ss) => {
                    return ss.id == bump?.bump_name;
                  });
                  return {
                    bump_type: bumpNew?.attributes?.bump_type,
                    bump_name: bumpNew?.attributes?.bump_name,
                    bump_multiplier: bump.bump_multiplier,
                    bump_amount: bump.bump_amount,
                    total_bump_cost: bump.bump_multiplier * bump.bump_amount,
                    pricing_bump_id: bumpNew?.attributes?.id,
                    feature_name: feature?.feature_name,
                    id: !isCreate ? bump?.id : undefined,
                  };
                }
              ),
            };
          }
        ),
        custom_payment_term_attributes: {
          is_upfront: this.state.is_unfront_payment,
          upfront_percentage:
            this.state.unfront_payment_type == "percentage"
              ? this.state.unfront_percentage
              : undefined,
          upfront_amount:
            this.state.unfront_payment_type == "lumpsump"
              ? this.state.unfront_lump_suump_amount
              : undefined,
          is_credit_card_upfront: this.state.is_credit_card_upfront,
          credit_card_upfront_percentage:
            this.state.credit_card_surcharge_type == "percentage"
              ? this.state.credit_card_upfront_percentage
              : undefined,
          credit_card_upfront_amount:
            this.state.credit_card_surcharge_type == "fixed"
              ? this.state.credit_card_upfront_amount
              : undefined,
          month: Math.round(
            this.state.totalContractValueAfterRemovingUnfrontAmount / 12
          ),
          quarter: Math.round(
            this.state.totalContractValueAfterRemovingUnfrontAmount / 4
          ),
          year: Math.round(
            this.state.totalContractValueAfterRemovingUnfrontAmount / 1
          ),
          weekly: Math.round(
            this.state.totalContractValueAfterRemovingUnfrontAmount / 52
          ),
          semi_annual: Math.round(
            this.state.totalContractValueAfterRemovingUnfrontAmount / 2
          ),
          total_amount: Math.round(this.state.totalContractValue),
          is_yearly_selected: values.is_yearly_payment_term,
          is_monthly_selected: values.is_monthly_payment_term,
          is_quarterly_selected: values.is_quarterly_payment_term,
          is_due_on_completion_selected: values.is_due_on_completion_payment_term,
          is_semi_annual_selected: values.is_semi_annual_payment_term,
          is_weekly_selected: values.is_weekly_payment_term,
          is_one_time_selected: values.is_one_time_payment_term,
        },
      },
    };
    return data;
  };
  createCustomPackageInDb = () => {
    // Guard against a second save firing before the first response returns, which would
    // create a duplicate package.
    if (this.state.isSavingCustomPackage) {
      return;
    }
    this.setState({ isSavingCustomPackage: true });
    this.props.showLoader();
    const headers = {
      "content-type": "application/json",
      token: this.state.token,
    };
    let method = "POST";
    let url = "bx_block_custom_packages/custom_package_creation";
    let isCreate = true;
    if (this.state.packageType == "package_management") {
      if (this.state.customPackageCreatedForDefaultPackage) {
        method = "PUT";
        url += "/" + this.state.customPackageCreatedForDefaultPackage?.id;
        isCreate = false;
      }
    } else if (this.state.packageType == "custom_package_management") {
      method = "PUT";
      url = `bx_block_custom_packages/custom_package_creation/${this.state.edit_package_id}`;
      isCreate = false;
    }
    const data = this.getCustomPackageData(isCreate);

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createCustomPackageCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      method
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
}
